/**
 * @flow
 * @relayHash f32a328fc8d65c80bade30ad726dc805
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type frontAppQueryVariables = {||};
export type frontAppQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +fullName: ?string,
  |}
|};
export type frontAppQuery = {|
  variables: frontAppQueryVariables,
  response: frontAppQueryResponse,
|};
*/


/*
query frontAppQuery {
  viewer {
    id
    fullName
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "fullName",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "frontAppQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "frontAppQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "frontAppQuery",
    "id": null,
    "text": "query frontAppQuery {\n  viewer {\n    id\n    fullName\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'bcd428ed3fcb222023e20d3c4bb9858e';
module.exports = node;
